'use client'

import { Accordion, Icon, Span, Link as ChakraLink, Stack, HStack, Box } from '@chakra-ui/react';
import React, { FC } from 'react'
import { Button } from '../ui/button';
import { FaRegUserCircle } from 'react-icons/fa';
import { useCategoriesQuery } from '@/queries/admin/categories/useCategoriesQuery';
import { Category } from '@/types/category';
import { I18nLink } from '../i18n/I18nLink';
import InstagramSvgIcon from '@/shared/icons/social/InstagramSvgIcon';
import WhatsappSvgIcon from '@/shared/icons/social/WhatsappSvgIcon';
import TiktokSvgIcon from '@/shared/icons/social/TiktokSvgIcon';
import { useLookbooksQuery } from '@/queries/lookbooks/useLookbooksQuery';
import { Lookbook } from '@/types/lookbook';
import { makeLookbookPageUrl } from '@/utils/product';
import ChevronRightLightSvgIcon from '@/shared/icons/ChevronRightLightSvgIcon';
import ChevronDownLightSvgIcon from '@/shared/icons/ChevronDownLightSvgIcon';
import { LinkButton } from '../ui/link-button';
import { useTranslations } from "next-intl";

interface MenuProps {

}

const Menu: FC<MenuProps> = () => {
  const t = useTranslations()
  const { data: categories, isLoading } = useCategoriesQuery();
  const { data: lookbooks, isLoading: lookbooksLoading } = useLookbooksQuery({ filter: { hidden: false } });

  const items = [
    { value: "a", title: t('catalog'), render: <CategoryLinks t={t} categories={categories ?? []} /> },
    { value: "b", title: t('lookbook'), render: <LookbookLinks t={t} lookbooks={lookbooks ?? []} /> },
  ]
  return (
    <Stack justifyContent={"space-between"} height="100%">
      <Stack align={"flex-start"} gap="0px" mb={'54px'}>
        <LinkButton href="/profile" variant={"plain"} px={0} pb="20px" textStyle={"medium20"} height={"auto"} w={"full"} justifyContent={"flex-start"}>
          <Icon>
            <FaRegUserCircle />
          </Icon>
          {t('your_profile')}
        </LinkButton>
        <Box py="20px" borderBottom="1px solid" borderColor="#DADADA" w="100%">
          <I18nLink href="/shop?filter[onSale]=true">
            <HStack gap="8px" cursor="pointer" justify="space-between">
              <Span textStyle={"bold20"} color={"accent.red"}>{t('sale')}</Span>
              <Icon boxSize={5} color="#1F1F1F" >
                <ChevronRightLightSvgIcon />
              </Icon>
              {/* <Span bg="brand" color="white" borderRadius="full" px="8px" py="2px" textStyle={"bold14"}>-20%</Span> */}
            </HStack>
          </I18nLink>
        </Box>
        <Accordion.Root collapsible defaultValue={["a"]} size={"lg"} borderTop={"1px solid"} borderColor={"#DADADA"}>
          {items.map((item, index) => (
            <Accordion.Item key={index} value={item.value} py={0} borderColor={"#DADADA"}>
              <Accordion.ItemTrigger py="20px">
                <Span flex="1" textStyle={"bold20"} lineHeight="28px">{item.title}</Span>
                <Accordion.ItemIndicator >
                  <Icon boxSize={6} color="#1F1F1F" >
                    <ChevronDownLightSvgIcon />
                  </Icon>
                </Accordion.ItemIndicator>
              </Accordion.ItemTrigger>
              <Accordion.ItemContent>
                <Accordion.ItemBody>{item.render}</Accordion.ItemBody>
              </Accordion.ItemContent>
            </Accordion.Item>
          ))}
        </Accordion.Root>
        <Stack gap="0px" w="full">
          {/* Обычная ссылка */}
          <Box py="20px" borderBottom="1px solid" borderColor="#DADADA">
            <I18nLink href="/shop/giftboxes">
              <HStack gap="8px" cursor="pointer" justify="space-between">
                <Span textStyle={"bold20"}>{t('gift_boxes')}</Span>
                <Icon boxSize={5} color="#1F1F1F" >
                  <ChevronRightLightSvgIcon />
                </Icon>
              </HStack>
            </I18nLink>
          </Box>
          <Box py="20px" borderBottom="1px solid" borderColor="#DADADA">
            <I18nLink href="/stores">
              <HStack gap="8px" cursor="pointer" justify="space-between">
                <Span textStyle={"bold20"}>{t('stores')}</Span>
                <Icon boxSize={5} color="#1F1F1F" >
                  <ChevronRightLightSvgIcon />
                </Icon>
              </HStack>
            </I18nLink>
          </Box>
          {/* Обычная ссылка */}
          <Box py="20px" borderBottom="1px solid" borderColor="#DADADA">
            <I18nLink href="/shop?filter[new]=true">
              <HStack gap="8px" cursor="pointer" justify="space-between">
                <Span textStyle={"bold20"} color={"accent"}>{t('new')}</Span>
                <Icon boxSize={5} color="#1F1F1F" >
                  <ChevronRightLightSvgIcon />
                </Icon>
                {/* <Span bg="brand" color="white" borderRadius="full" px="8px" py="2px" textStyle={"bold14"}>-20%</Span> */}
              </HStack>
            </I18nLink>
          </Box>
          <Box py="20px" borderBottom="1px solid" borderColor="#DADADA">
            <I18nLink href="/corporate">
              <HStack gap="8px" cursor="pointer" justify="space-between">
                <Span textStyle={"bold20"}>
                  {t('for_corporate_clients')}
                </Span>
                <Icon boxSize={5} color="#1F1F1F" >
                  <ChevronRightLightSvgIcon />
                </Icon>
              </HStack>
            </I18nLink>
          </Box>
        </Stack>
      </Stack>
      <SocialLinks />
    </Stack>
  )
}

const CategoryLinks: FC<{ categories: Category[], t: any }> = ({ categories, t }) => (
  <Stack gap="16px">
    <ChakraLink asChild textStyle={"regular16"}>
      <I18nLink href="/shop">{t('all')}</I18nLink>
    </ChakraLink>
    {categories.map((item, idx) => (
      <ChakraLink key={idx} asChild textStyle={"regular16"}>
        <I18nLink href={`/shop/${item.slug}`}>{item.name}</I18nLink>
      </ChakraLink>
    ))}
  </Stack>
);

const LookbookLinks: FC<{ lookbooks: Lookbook[], t: any }> = ({ lookbooks, t }) => (
  <Stack gap="16px">
    <ChakraLink asChild textStyle={"regular16"}>
      <I18nLink href="/shop/lookbook">{t('all')}</I18nLink>
    </ChakraLink>
    {lookbooks.map((item, idx) => (
      <ChakraLink key={idx} asChild textStyle={"regular16"}>
        <I18nLink href={makeLookbookPageUrl(item)}>{item.name}</I18nLink>
      </ChakraLink>
    ))}
  </Stack>
);

const SocialLinks: FC = () => (
  <Stack direction="row" gap="16px" pb={'34px'}>
    <I18nLink href={"http://wa.me/77082405949"}>
      <Icon boxSize={6} cursor="pointer" color={"text.muted"}>
        <WhatsappSvgIcon />
      </Icon>
    </I18nLink>
    <I18nLink href={"https://instagram.com/qazaq.republic"}>
      <Icon boxSize={6} cursor="pointer" color={"text.muted"}>
        <InstagramSvgIcon />
      </Icon>
    </I18nLink>
    <I18nLink href={"https://www.tiktok.com/@qazaq.republic"}>
      <Icon boxSize={6} cursor="pointer" color={"text.muted"}>
        <TiktokSvgIcon />
      </Icon>
    </I18nLink>
  </Stack>
);

Menu.displayName = "Menu";

export default Menu;